// extracted by mini-css-extract-plugin
export default {"SingleInputForm":"SingleInputForm_SingleInputForm__3SifZ","top":"SingleInputForm_top__Q-OUX","bot":"SingleInputForm_bot__JKu8V"};